import React, { useEffect } from 'react'
import { Grid } from '@material-ui/core';

import './index.scss'
import { useMedia } from '@commons/media';
import RootStore from '@stores';

interface AccountSelectProps {
    select: number,
    mgmAccounts: any,
    onChange: (arg0: number) => void,
}
const AccountSelect:React.FC<AccountSelectProps> = (props)=> {
    const {mediaClass} = useMedia()
    const {select, onChange} = props
    const {
        mgmAccounts
    } = props;

    const {
        portalContent
    } = RootStore.PortalStore;

    const preloadImages = () => {
        const imageUrls = [
            mgmAccounts.referrerSelectedIconImageUrl,
            mgmAccounts.referrerUnselectedIconImageUrl,
            mgmAccounts.newCustomerSelectedIconImageUrl,
            mgmAccounts.newCustomerUnselectedIconImageUrl
        ];

        imageUrls.forEach(url => {
            if (url) {
                const img = new Image();
                img.src = url;
            }
        });
    };

    useEffect(() => {
        preloadImages();
    }, [mgmAccounts]); 

    const computedBg = (flag: string) => {
        if (flag === 'selected') {
            return select === 0 ? portalContent?.mgmAccounts?.accountIconSelectedColor ? portalContent.mgmAccounts.accountIconSelectedColor : '#f68a33' : portalContent?.mgmAccounts?.accountIconUnselectedColor || '#fff'
        }
        return select === 1 ? portalContent?.mgmAccounts?.accountIconSelectedColor ? portalContent.mgmAccounts.accountIconSelectedColor : '#f68a33' : portalContent?.mgmAccounts?.accountIconUnselectedColor || '#fff'
    }

    return (
        <Grid className={`${mediaClass('account-select')}`}>
            <div className={`${mediaClass('account-select-item')} ${select === 0 ? 'account-select-active': 'account-select-default'}`} onClick={() => onChange(0)} style={{backgroundColor: `${computedBg('selected')}`}}>
                <div className="account-select-icon" style={{backgroundImage: `url(${ select === 0 ? mgmAccounts.referrerSelectedIconImageUrl : mgmAccounts.referrerUnselectedIconImageUrl})`}}></div>
                <div>{mgmAccounts.referrerButtonText}</div>
            </div>
            <div className={`${mediaClass('account-select-item')} ${select === 1 ? 'account-select-active': 'account-select-default'}`} onClick={() => onChange(1)} style={{backgroundColor: `${computedBg('unselected')}`}}>
                <div className="account-select-icon" style={{backgroundImage: `url(${ select === 1 ? mgmAccounts.newCustomerSelectedIconImageUrl : mgmAccounts.newCustomerUnselectedIconImageUrl})`}}></div>
                <div>{mgmAccounts.newCustomerButtonText}</div>
            </div>
        </Grid>
    )
}

export default AccountSelect;
